export default "__VITE_PUBLIC_ASSET__fb91ba94__"